var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('h3',{staticClass:"text-sm font-normal text-gray-800"},[_vm._v(" "+_vm._s(_vm.offerLine.description)+" ")])]),_c('td',{staticClass:"text-right text-sm text-gray-800"},[(_vm.freeOfCharge)?_c('span',{staticClass:"uppercase"},[_vm._v("included")]):_c('span',{staticClass:"tabular-nums"},[_vm._v(_vm._s(_vm.price)+" €")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }